import { z } from "zod";
const EnvType = z.union([
  z.literal("development"),
  z.literal("preview"),
  z.literal("production"),
]);
/**
 * Specify your server-side environment variables schema here.
 * This way you can ensure the app isn't built with invalid env vars.
 */
export const ServerSchema = z.object({
  VERCEL_URL: z.string(),
  VERCEL_ENV: EnvType,
  RAILS_API_ENDPOINT: z.string(),
  AUTH_EXPIRY_SECONDS: z.coerce.number(),
  AWS_S3_TEMP_STORAGE_BUCKET: z.string(),
  AWS_S3_TEMP_STORAGE_ACCESS_KEY: z.string(),
  AWS_S3_TEMP_STORAGE_SECRET: z.string(),
  AWS_S3_TEMP_STORAGE_REGION: z.string(),
  /** When set, S3 uses Vercel OIDC via this role. Otherwise static access keys are used. */
  AWS_ROLE_ARN: z.string().optional(),
  APP_NAME: z.string(),
  APP_ID: z.string(),
});
export type ServerSchema = z.infer<typeof ServerSchema>;

/**
 * Specify your client-side environment variables schema here.
 * This way you can ensure the app isn't built with invalid env vars.
 * To expose them to the client, prefix them with `NEXT_PUBLIC_`.
 */
export const ClientSchema = z.object({
  NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: z.string(),
  NEXT_PUBLIC_APP_ID: z.string(),
  NEXT_PUBLIC_APP_NAME: z.string(),
  NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: z.string(),
});
export type ClientSchema = z.infer<typeof ClientSchema>;
